/*
  Opens the cart drawer on add-to-cart instead of full-page navigating to /cart.

  Why this file exists: the method-first buy forms (opp-mh-hero, opp-mh-close)
  are plain {% form 'product' %} POSTs to /cart/add, so the browser navigates
  to /cart. That page is stock Dawn — its Check out button sits a full screen
  below the fold on a phone, behind the four-row bonus block, with "Continue
  shopping" as the loudest control above it. Aug 9-13 2026: 69 add-to-carts
  produced 9 checkouts. This keeps the shopper on the page they were sold on.

  It is deliberately NOT Dawn's <product-form> element. That class dereferences
  .loading__spinner and a <span> inside the submit button with no null guard,
  neither of which the opp-mh button markup has; wrapping the forms would mean
  restructuring a carefully-styled CTA and inheriting Dawn's .loading CSS.

  PROGRESSIVE ENHANCEMENT, on purpose: every failure path leaves the native
  POST intact. No <cart-drawer> in the DOM (cart_type != 'drawer'), a network
  error, a cart error, an exception while binding -> the form submits normally
  and the shopper lands on /cart exactly as before. This is the only buy button
  on the store; it must not be possible for this file to swallow a sale.

  Cart line-item properties ride along untouched via FormData, so the bundle
  rows (and the Aug 19 book gate) reach the cart and the confirmation email
  the same way they do today.
*/
(function () {
  'use strict';

  var BOUND = 'oppDrawerBound';

  function getDrawer() {
    var el = document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' ? el : null;
  }

  function sectionIds(drawer) {
    try {
      return drawer
        .getSectionsToRender()
        .map(function (s) {
          return s.id;
        })
        .join(',');
    } catch (e) {
      return '';
    }
  }

  // Native submit: bypasses this handler, so it is a genuine fallback and
  // cannot recurse.
  function fallback(form) {
    HTMLFormElement.prototype.submit.call(form);
  }

  function onSubmit(evt) {
    var form = evt.currentTarget;
    var drawer = getDrawer();
    if (!drawer) return; // no drawer on the page -> let the POST happen

    evt.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('opp-cta-loading');
    }

    function release() {
      if (!button) return;
      button.removeAttribute('aria-disabled');
      button.classList.remove('opp-cta-loading');
    }

    var body = new FormData(form);
    var ids = sectionIds(drawer);
    if (ids) {
      body.append('sections', ids);
      body.append('sections_url', window.location.pathname);
    }
    drawer.setActiveElement(button || document.activeElement);

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // A cart error (sold out, bad variant) comes back with .status set.
        // Hand it to the normal POST so Shopify renders its own error page
        // rather than failing silently on a page that looks like it worked.
        if (!data || data.status) {
          fallback(form);
          return;
        }
        // Dawn clears .is-empty in product-form.js, NOT in cart-drawer.js, so
        // renderContents alone leaves it set. With it set the drawer opens but
        // its contents collapse and .drawer__inner stays parked off-screen
        // (measured at x:375 on a 375px viewport) — an empty white panel with
        // the Check out button just past the right edge. Must clear it here.
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'opp-cart-drawer',
            cartData: data,
          });
        }
        release();
      })
      .catch(function () {
        fallback(form);
      });
  }

  function bind() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.closest('product-form')) return; // Dawn already AJAXes these
      if (form.dataset[BOUND]) return;
      form.dataset[BOUND] = '1';
      form.addEventListener('submit', onSubmit);
    });
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }
    // Theme editor re-renders sections without a page load.
    document.addEventListener('shopify:section:load', bind);
  } catch (e) {
    /* leave every form on its native POST */
  }
})();
